export class Feedback {
  constructor(
    public groupId: number,
    public matrixGroupId: number,
    public text: string,
  ) {}
}
